{
  "bumps": {"major": "Major", "minor": "Minor", "patch": "Patch"},
  "confirmed": {"bump": "{{subject}}: {{bump}}", "changeLine": "Change line: {{line}}"},
  "contentVersions": {
    "loading": "Reading the content versions…",
    "none": "No content version has changed what this process schema reads."
  },
  "corpus": "Corpus",
  "edit": {
    "derive": "Save as a new process schema derived from {{workflow}} {{version}}",
    "deriveUnlabelled": "Save as a new process schema derived from {{workflow}}",
    "loading": "Reading how this process schema can be changed…",
    "unavailable": {
      "library": "This process schema comes from a library, which updates it. Save your change as a derived process schema."
    },
    "update": "Update {{workflow}} to {{version}}",
    "updateUnlabelled": "Update {{workflow}}"
  },
  "label": "{{name}} {{version}}",
  "merge": {
    "bumpFor": "Version change for {{subject}}",
    "bumpGives": "{{bump}} → {{version}}",
    "changeLine": "Change line, shown with the new versions",
    "draft": "Draft based on {{current}} · proposes {{proposed}}",
    "loading": "Reading the proposed versions…",
    "mayChangeMethod": "Major if it changes what the step does",
    "new": "New: starts at 1.0.0",
    "planFailed": "Without the proposal, merging keeps DMW's proposed versions unconfirmed.",
    "proposedBump": "{{bump}} (proposed)",
    "removed": "Removed: gets no new version",
    "title": "Versions",
    "unchanged": "Stays at {{current}}"
  },
  "projectContent": "Project content",
  "reasons": {
    "content_changed": "content changed",
    "documents_added": "documents added",
    "documents_changed": "documents changed",
    "documents_removed": "documents removed",
    "editorial": "wording only",
    "graph_changed": "moved between the data model and the process ontology",
    "inputs_accept_less": "inputs accept less",
    "inputs_added": "optional inputs added",
    "inputs_became_required": "inputs became required",
    "inputs_removed": "inputs removed",
    "items_added": "items added",
    "items_removed": "items removed",
    "label_terms_changed": "terms of labels changed",
    "labels_added": "labels added",
    "labels_changed": "labels changed",
    "labels_removed": "labels removed",
    "lifecycle_changed": "lifecycle state changed",
    "outputs_added": "outputs added",
    "outputs_changed_kind": "outputs changed kind",
    "outputs_removed": "outputs removed",
    "placeholders_changed": "placeholders changed",
    "prompt_text_changed": "prompt text changed",
    "required_inputs_added": "required inputs added",
    "retired": "retired",
    "shapes_added": "shapes added",
    "shapes_changed": "shapes changed",
    "statements_changed": "other statements changed",
    "step_kind_changed": "step kind changed",
    "step_method_changed": "a step's method changed",
    "step_prompt_changed": "a step's prompt changed",
    "step_tool_changed": "a step's tool changed",
    "step_versions_changed": "step versions changed",
    "steps_added": "steps added",
    "steps_removed": "steps removed",
    "steps_reordered": "steps reordered",
    "steps_replaced": "steps replaced",
    "term_hierarchy_changed": "term hierarchy changed",
    "term_signatures_changed": "domains or ranges of terms changed",
    "terms_added": "terms added",
    "terms_removed": "terms removed",
    "terms_renamed": "terms renamed",
    "tool_code_changed": "tool code changed",
    "tool_interface_changed": "tool interface changed",
    "wiring_changed": "connections between steps changed"
  },
  "unlabelled": "No version label"
}
